module.exports = __webpack_public_path__ + "img/water-pump-2.6fa27650.png";